import { HttpClient, HttpEvent } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { CrudRowsService, CrudService, ENVIRONMENT, FileUploadService, FullyEncodedHttpParams, HateoasMultipleResponseObject, PageSpecification, REPOSITORY_FILE_TYPE, RepositoryFile, RepositoryFileReference, TokenStorage, UploadFile, appendSerialisedHttpParams, markAsBackgroundServiceCall, urlWithParams } from '@scisys-uim/uim-common';
import { Observable } from 'rxjs';


export type AssetMaintenanceDocumentPermission = 'READ' | 'UPLOAD';

@Injectable({
  providedIn: 'root'
})
export class AssetMaintenanceDocumentService extends CrudService<RepositoryFile, RepositoryFileReference> {

  servicePath: string = '/asset-mnt-document';

  constructor(protected http: HttpClient,
    protected fileUploadService: FileUploadService,
    @Inject(ENVIRONMENT) protected environment: any,
    private tokenStorage: TokenStorage) {
    super(http, environment, REPOSITORY_FILE_TYPE.entityDecorator);
  }

  getBlacklistedContentTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.serviceBaseUrl + '/blacklistedContentTypes');
  }
  getBlacklistedExtensions(): Observable<string[]> {
    return this.http.get<string[]>(this.serviceBaseUrl + '/blacklistedExtensions');
  }
  getWhitelistedContentTypes(): Observable<string[]> {
    return this.http.get<string[]>(this.serviceBaseUrl + '/whitelistedContentTypes');
  }
  getWhitelistedExtensions(): Observable<string[]> {
    return this.http.get<string[]>(this.serviceBaseUrl + '/whitelistedExtensions');
  }

  getAssetMntPermissions(assetMntId: number): Observable<AssetMaintenanceDocumentPermission[]> {
    return this.http.get<AssetMaintenanceDocumentPermission[]>(this.serviceBaseUrl + '/getAssetMntDocumentPermissions/' + assetMntId);
  }

  protected uploadFile(file: UploadFile, servicePath: string): Observable<HttpEvent<RepositoryFile>> {
    return this.fileUploadService.uploadRepositoryFile(file, servicePath);
  }

  findAssetMntDocuments(assetMntId: number): Observable<HateoasMultipleResponseObject<RepositoryFile>> {
    var params = null;
    return this.deserialiseMultipleResponseListAsHateoas(this.http.get<RepositoryFile[]>(this.serviceBaseUrl + '/findAllAssetMntDocuments/' + assetMntId, {
      params: params
    }));
  }

  countAssetMntDocuments(assetMntId: number): Observable<number> {
    var params = null;
    return this.http.get<number>(this.serviceBaseUrl + '/countAllAssetMntDocuments/' + assetMntId, {
      params: params
    });
  }

  exportAssetMntDocumentByFilename(assetMntId: number, file: RepositoryFile, download?: boolean): string {
    var params = new FullyEncodedHttpParams();
    params = appendSerialisedHttpParams(!!download, "download", params);
    params = appendSerialisedHttpParams(file.filePath, "filename", params);
    params = this.tokenStorage.appendAuthenticationHttpParams(params);
    return urlWithParams(this.serviceBaseUrl + '/exportAssetMntDocumentByFilename/' + assetMntId, params);
  }

  exportMultipleAssetMntDocumentsAsZipByFileSpecification(assetMntId: number): string {
    var params = appendSerialisedHttpParams(params);
    params = this.tokenStorage.appendAuthenticationHttpParams(params);
    return urlWithParams(this.serviceBaseUrl + '/exportMultipleAssetMntDocumentsAsZipByFileSpecification/' + assetMntId, params);
  }

  uploadAssetMntDocument(assetMntId: number, file: UploadFile): Observable<HttpEvent<RepositoryFile>> {
    return this.uploadFile(file, this.serviceBaseUrl + "/uploadAssetMntDocument/" + assetMntId);
  }

  deleteAssetMntDocument(assetMntId: number, file: RepositoryFile) {
    var params = new FullyEncodedHttpParams();
    params = appendSerialisedHttpParams(file.filePath, 'filename', params);
    return this.http.delete(this.serviceBaseUrl + '/deleteAssetMntDocument/' + assetMntId, {
      params: params
    });
  }

  public get(key: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public findAll(): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public findAllPaginated(pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public existsById(id: RepositoryFileReference): Observable<boolean> { throw new Error('Not implemented'); }
  public create(item: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public save(item: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public persistAll(rows: RepositoryFile[]): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public delete(id: RepositoryFileReference): Observable<void> { throw new Error('Not implemented'); }

}

@Injectable({
  providedIn: 'root'
})
export class AssetMaintenanceDocumentRowsService extends CrudService<RepositoryFile, RepositoryFileReference> implements CrudRowsService<RepositoryFile, RepositoryFileReference, any> {

  servicePath: string = null;

  constructor(protected service: AssetMaintenanceDocumentService) {
    super(null, null, REPOSITORY_FILE_TYPE.entityDecorator);
  }

  findAllDocuments(assetMntId: number): Observable<HateoasMultipleResponseObject<RepositoryFile>> {
    return this.service.findAssetMntDocuments(assetMntId);
  }

  exportDocumentByFilename(assetMntId: number, file: RepositoryFile, download?: boolean) {
    return this.service.exportAssetMntDocumentByFilename(assetMntId, file, download);
  }

  exportMultipleDocumentsAsZipByFileSpecification(assetMntId: number): string {
    return this.service.exportMultipleAssetMntDocumentsAsZipByFileSpecification(assetMntId);
  }

  uploadFile(assetMntId: number, file: UploadFile): Observable<HttpEvent<RepositoryFile>> {
    return this.service.uploadAssetMntDocument(assetMntId, file);
  }

  deleteDocumentByFilename(assetMntId: number, file: RepositoryFile) {
    return this.service.deleteAssetMntDocument(assetMntId, file);
  }

  public findAllInGroup(key: any): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public get(key: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public findAll(): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public findAllPaginated(pageSpec: PageSpecification): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public existsById(id: RepositoryFile): Observable<boolean> { throw new Error('Not implemented'); }
  public create(item: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public save(item: RepositoryFile): Observable<RepositoryFile> { throw new Error('Not implemented'); }
  public persistAll(rows: RepositoryFile[]): Observable<HateoasMultipleResponseObject<RepositoryFile>> { throw new Error('Not implemented'); }
  public delete(id: RepositoryFileReference): Observable<void> { throw new Error('Not implemented'); }
}

